import { render } from "./ChannelAndCategory.vue?vue&type=template&id=2ccf2658&scoped=true"
import script from "./ChannelAndCategory.vue?vue&type=script&lang=js"
export * from "./ChannelAndCategory.vue?vue&type=script&lang=js"

import "./ChannelAndCategory.vue?vue&type=style&index=0&id=2ccf2658&lang=scss&scoped=true"
import "./ChannelAndCategory.vue?vue&type=style&index=1&id=2ccf2658&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccf2658"]])

export default __exports__